module.exports = __webpack_public_path__ + "static/media/x.48d0f569.svg";